import clsx from 'clsx';

import type { ComponentProps } from 'react';

import s from './ModalActions.module.css';

type ModalActionsProps = ComponentProps<'div'>;

export const ModalActions = ({ children, className, ...props }: ModalActionsProps) => (
  <div className={clsx(s.actions, className)} {...props}>
    {children}
  </div>
);
